import autoSchedulingPatchesModule from '../../autoScheduling';

export default instance => {
  instance.attachEvent('onBeforeAutoSchedule', taskId => {
    autoSchedulingPatchesModule.saveDatesOfProjectTasks();

    if (instance.isTaskExists(taskId)) {
      const task = instance.getTask(taskId);

      return autoSchedulingPatchesModule.onBeforeAutoSchedule(task);
    }

    return true;
  });
  instance.attachEvent('onAutoScheduleCircularLink', (cycles, tasks = []) => {
    autoSchedulingPatchesModule.autoScheduleCircularLink(cycles, tasks);
  });
};
